module.exports = __webpack_public_path__ + "img/labmem_text_language_kr.a3171ade.png";